import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import CustomPage from "../../components/CustomPage";
import { useDispatch, useSelector } from "react-redux";
import { Card, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import http from "../../http";
import { endpointNameList } from "./const";
import { ROLES_ID } from "config/roles";
import { setShowLoading } from "store/sysSlice";
import CustomCard from "components/CustomCard";
import { PersonOutlineOutlined, PhoneOutlined } from "@mui/icons-material";

const ClientsCheckList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { bt } = useBizTypeTranslation();
  const list = useSelector((state) => state?.clients?.list);
  const userRole = useSelector((state) => state.userSettings?.user?.userRole);
  const [checkListByQty, setCheckListByQty] = useState([]);
  const [clients, setClients] = useState([]);

  useEffect(() => {
    dispatch(setShowLoading(true));
    http.get(`/${endpointNameList}/byQty`).then((res) => {
      if (res?.data?.id === 1) {
        const qtyList = res?.data?.data
        if (userRole === ROLES_ID.EMPLOYEE) {
          let newList = []
          list
            ?.filter(client => client?.hasCheckList)
            ?.map(i => { if (qtyList?.some(item => item?.clientId === i?._id)) newList.push(i) })
          setClients(newList)
        }
        else {
          setClients(list?.filter(client => client?.hasCheckList))

        }
        setCheckListByQty(qtyList);
        dispatch(setShowLoading(false));
      }
    })
  }, [list]);

  const onSelectedClient = (client) => {
    navigate(`/Check-List/${client?._id}`);
  }

  return (
    <CustomPage hidePadding>
      <Stack padding={2} spacing={2} direction="row" useFlexGap flexWrap="wrap">
        {clients?.map((client, idx) => {
          const checkList = checkListByQty?.find(c => c?.clientId === client?._id);
          return (
            <CustomCard
              key={idx}
              onClick={() => onSelectedClient(client)}
              sx={{
                width: { xs: "100%", md: 300 },
                height: 150,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: "space-between",
                cursor: "pointer",
              }}
            >
              <Stack spacing={2}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent='space-between'
                >
                  <Typography >
                    {client?.company || client?.contactName}
                  </Typography>
                </Stack>

                <Stack spacing={0.5}>
                  <Stack direction="row" spacing={2}>
                    <PersonOutlineOutlined fontSize="small" sx={{ color: "primary.main" }} />
                    <Typography>{client?.contactName}</Typography>
                  </Stack>

                  <Stack direction="row" spacing={2}>
                    <PhoneOutlined fontSize="small" sx={{ color: "primary.main" }} />
                    <Typography>{client?.tel}</Typography>
                  </Stack>

                </Stack>
              </Stack>

              <Stack borderTop={1} width="100%" textAlign="center" padding={1}>
                {checkList?.qty > 0
                  ? <Typography fontWeight='bold'>
                    {bt("RECORDS")} ({checkList?.qty})
                  </Typography>
                  : <Typography fontWeight='bold' >
                    {bt("NO_RECORDS")}
                  </Typography>
                }
              </Stack>
            </CustomCard>
          )
        })}
      </Stack>
    </CustomPage>
  );
};
export default ClientsCheckList;
